module.exports = __webpack_public_path__ + "static/media/logo2.f8c1b611.png";